import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './OnboardingContainerAA.css';

class Restart extends Component {
    constructor(props) {
        super(props);
    }


    componentDidMount(){
        try {
            let domArray = document.getElementsByName("restartDom");
            domArray.forEach(element => {
                element.parentNode.style.display = 'none';
            });
          } catch (error) {
              console.log(error);
          }
    }


    render() {
        return (
            <div name="restartDom"></div>
        )
    }
}

Restart.propTypes = {
    steps: PropTypes.object,
};
  
Restart.defaultProps = {
steps: undefined,
};
  

export default Restart



// WEBPACK FOOTER //
// ./src/views/onboardingAA/Restart.js